import { ReactComponent as CheckIcon } from "../../assets/icons/tick-icon.svg";
import CrossIcon from "../../assets/icons/cross-icon";
import { useTranslation } from "react-i18next";
import { ProgressButton } from "./ProgressButton";

const MAX_SCREEN_TIME = 2000;
type Props = {
    timeLeft: number;
    onJobsClick: () => void;
};
const ProfileUpdateScreen = ({ timeLeft, onJobsClick }: Props) => {
    const { t } = useTranslation()

    return (
        <div className="flex h-screen items-center justify-center text-onSurface-primary">
            <div className="fixed top-0 right-6 flex h-12 items-center">
                <div onClick={onJobsClick}>
                    <CrossIcon />
                </div>
            </div>
            <div className="relative -top-16 text-center">
                <CheckIcon className="m-auto mb-4 h-16 w-auto" />
                <div className="text-xl font-semibold">Congratulations</div>
                <div className="text-base">{t('EXIT.PROFILE_UPDATED')}</div>
            </div>
            <footer
                className="fixed bottom-0 mx-auto w-full bg-[#FFFFFF] px-4 py-4"
                style={{
                    boxShadow:
                        "0px 0px 4px rgba(0, 0, 0, 0.16), 0px 8px 16px rgba(0, 0, 0, 0.12)",
                }}
            >
                <ProgressButton
                    width="100%"
                    text="See jobs"
                    textColor='#fff'
                    primaryColor="#1F8268"
                    secondaryColor="#005F3E"
                    duration={2000}
                    onClick={onJobsClick}
                    onCompletion={onJobsClick}
                />
                
            </footer>
        </div>
    );
};

export default ProfileUpdateScreen;
